import { Table } from '@octano/global-ui';
import { useColumns } from '../hooks/useColumns';
import { useTexts } from '../hooks/useTexts';
import { TutorsResponse } from '../types';

type Props = {
  tutorsData: TutorsResponse;
};

export function TutorsTable({ tutorsData }: Props) {
  const texts = useTexts();
  const data = useColumns(tutorsData.studentPlansAndTutors.studyPlans);
  return (
    <>
      <Table
        data={data.studyPlans}
        noResultsText={useTexts().noResults}
        columns={[
          {
            headerText: texts.table.studyPlan,
            columnName: 'name',
            width: '25%',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
          {
            headerText: texts.table.nameAndId,
            columnName: 'tutor',
            width: '25%',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
          {
            headerText: texts.table.email,
            columnName: 'tutorEmail',
            width: '25%',
            thClassName: 'text-center',
            tdClassName: 'text-center',
          },
        ]}
      />
    </>
  );
}
